export default __webpack_public_path__ + "static/media/img-monochrome-full-logo.4e514e79.jpg";